import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Radio, Space} from "antd";
import useTableActions from "../../hooks/useTableActions";
import exportToExcel from "../../components/ExportToExcel";
import {FileExcelOutlined} from "@ant-design/icons";
import useStatsDescTabData from "./useStatsDescTabData";
import {STATS_DESC} from "../../store/types/references/statsDesc/statsDesc";
import Search from "antd/es/input/Search";
import {useTranslation} from "react-i18next";

const useStatsDescTab = (setIsModalOpen) => {

    const data = useSelector((state) => state.statsDesc.data);
    const totalItems = useSelector((state) => state.statsDesc.totalItems);
    const loading = useSelector((state) => state.statsDesc.loading);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const [filterValue, setFilterValue] = useState("");
    const [filterFilialValue, setFilterFilialValue] = useState("");

    const {mainStatsDescTabColumns, mainStatsDescTabData, mainAccStatsDescTabColumns, mainAccStatsDescTabData} = useStatsDescTabData();
    const [groupSettings, setGroupSettings] = useState({
        type: 'account',
        title: 'actionsInfo', // i18n dashboar prop
        data: mainAccStatsDescTabData,
        columns: mainAccStatsDescTabColumns
    });

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const {rowSelection, pagination, onRow} = useTableActions(totalItems, selectedRowKeys,setSelectedRow, setSelectedRowKeys, groupSettings.type);


    const getTabData = async () => {


        let bodyData = groupSettings.data
        let filters = [];
        if (groupSettings.type === 'account' && filterValue !== '' && filterValue.length !== 0) {
            filters = [
                { "column": "account", "operator": "_like_", "datatype":"text", "value":filterValue},
            ]
        }
        if (groupSettings.type === 'account' && filterFilialValue !== '' && filterFilialValue.length !== 0) {
            filters = [...filters,
                { "column": "filial", "operator": "=", "dataType":"text", "value":filterFilialValue},
            ]
        }
        bodyData.query['filters'] = filters
        bodyData.query['context'] = "userFilialFilterContextStrategy"

       /* if (filterData && filters.length === 0) {
            filters = [...filters, ...filterData];
        }*/

        dispatch({type: STATS_DESC, selectedTypeData: bodyData});
        setSelectedRow(null);
        setSelectedRowKeys([]);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {
        getTabData();
    }, [groupSettings.type, filterValue, filterFilialValue]);

    const groupTypeMappings= useMemo(()=> ({
        filial: {dataType: mainStatsDescTabData, columns: mainStatsDescTabColumns, tabTitle: 'Худудлар бўйича қолдиқлар'},
        account: {dataType: mainAccStatsDescTabData, columns: mainAccStatsDescTabColumns, tabTitle: 'Хисоб рақамлар бўйича қолдиқлар'}
    }), [mainStatsDescTabData, mainStatsDescTabColumns, mainAccStatsDescTabData, mainAccStatsDescTabColumns])

    const handleGroupType = useCallback((evt) => {
        if (groupSettings.type !== evt) {
            const {dataType, columns, tabTitle} = groupTypeMappings[evt];
            setGroupSettings({
                type: evt,
                title: tabTitle,
                data: dataType,
                columns: columns
            });
        }
    }, [groupSettings.type, groupTypeMappings]);

    const handleExport = useCallback(() => {
        exportToExcel(data, groupSettings.columns)
    }, [data, groupSettings.columns]);

    const onAccSearch = (value, _e, info) => {
        setFilterValue( value );
    };

    const onFilialSearch = (value, _e, info) => {
        console.log(value, 'value etetet')
        setFilterFilialValue( value );
    };

    const tableHeader = useMemo(() => {
        return () => (

                <Space>
                    <Radio.Group value={groupSettings.type} onChange={(e) => handleGroupType(e.target.value)}>
                        <Radio.Button value="account">{t('acc')}</Radio.Button>
                        <Radio.Button value="filial">{t('filial')}</Radio.Button>
                    </Radio.Group>

                    {
                        groupSettings.type === 'account' &&
                        <>
                        <Search
                            placeholder={t('acc')}
                            allowClear
                            defaultValue={filterValue}
                            size="middle"
                            onSearch={onAccSearch}
                        />
                        <Search
                            placeholder={t('filial')}
                            allowClear
                            defaultValue={filterFilialValue}
                            size="middle"
                            //onPressEnter={(value) => onFilialSearch(value)}
                            onSearch={onFilialSearch}
                        />
                        </>
                    }

                    {/*<FilterModal filterKey={filterKey} filterTab={filterTab} onSubmit={getTabData}/>*/}

                <Button type="primary" shape="circle" onClick={handleExport}>
                    <FileExcelOutlined/>
                </Button>
                </Space>

        );
    }, [groupSettings.type, handleGroupType, handleExport])

    return {selectedTypeColumn: groupSettings.columns,tableHeader,data,rowSelection,loading,pagination,onRow,selectedRow, handleOk, handleCancel, groupTypeTitle: groupSettings.title};
};

export default useStatsDescTab;